import React from 'react';
import { GridIconSvg } from '../../assets/img/GridIconSvg';
import { ListIconSvg } from '../../assets/img/ListIconSvg';
import { IconButton } from '../common/IconButton';
import { useDataView } from '../../hooks/useDataView';

export const DataViewSwitch: React.FC<ReturnType<typeof useDataView>> = ({
  dataView,
  setDataView,
}) => {
  const icon = dataView === 'list' ? <GridIconSvg /> : <ListIconSvg />;
  const switchTo = dataView === 'list' ? 'grid' : 'list';
  return (
    <IconButton
      aria-label={`Switch to ${switchTo}`}
      icon={icon}
      variant='outlined'
      onClick={() => setDataView(switchTo)}
    />
  );
};
